import * as types from '../../lib/actionTypes.es6';

export function getEngineConfigsRequest(partner) {
  return { type: types.GET_ENGINE_CONFIGS_REQUEST, payload: partner };
}
export function getEngineConfigsSuccess(configs) {
  return { type: types.GET_ENGINE_CONFIGS_SUCCESS, payload: configs };
}
export function getEngineConfigsFail(error) {
  return { type: types.GET_ENGINE_CONFIGS_FAIL, payload: error };
}

export function getEngineConfigRawRequest(partner, process, identifierType) {
  return { type: types.GET_ENGINE_CONFIG_RAW_REQUEST, payload: { partner, process, identifierType } };
}
export function getEngineConfigRawSuccess(raw) {
  return { type: types.GET_ENGINE_CONFIG_RAW_SUCCESS, payload: raw };
}
export function getEngineConfigRawFail(error) {
  return { type: types.GET_ENGINE_CONFIG_RAW_FAIL, payload: error };
}
export function getEngineConfigRawReset() {
  return { type: types.GET_ENGINE_CONFIG_RAW_RESET };
}

export function publishEngineConfigRequest(partner, process, identifierType, rawYaml) {
  return { type: types.PUBLISH_ENGINE_CONFIG_REQUEST, payload: { partner, process, identifierType, rawYaml } };
}
export function publishEngineConfigSuccess(result) {
  return { type: types.PUBLISH_ENGINE_CONFIG_SUCCESS, payload: result };
}
export function publishEngineConfigFail(error) {
  return { type: types.PUBLISH_ENGINE_CONFIG_FAIL, payload: error };
}
export function publishEngineConfigReset() {
  return { type: types.PUBLISH_ENGINE_CONFIG_RESET };
}

export function createEngineConfigRequest(partner, rawYaml) {
  return { type: types.CREATE_ENGINE_CONFIG_REQUEST, payload: { partner, rawYaml } };
}
export function createEngineConfigSuccess(result) {
  return { type: types.CREATE_ENGINE_CONFIG_SUCCESS, payload: result };
}
export function createEngineConfigFail(error) {
  return { type: types.CREATE_ENGINE_CONFIG_FAIL, payload: error };
}
export function createEngineConfigReset() {
  return { type: types.CREATE_ENGINE_CONFIG_RESET };
}
